<app-automation-builder-form-setup title="Edit Triggers">
  <ng-container middle [formGroup]="form">
    <mat-form-field class="animate__animated animate__fadeInDown animate__faster">
      <mat-label>Trigger</mat-label>
      <mat-select formControlName="trigger">
        <mat-option *ngFor="let trigger of triggers" [value]="trigger.value">
          <span>{{ trigger.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="trigger$ | async as trigger">
      <ng-container *ngIf="trigger === TriggerType.AttributeChange">
        <mat-form-field class="animate__animated animate__fadeInDown animate__faster">
          <mat-label>Attribute</mat-label>
          <mat-select formControlName="objectFieldDef">
            <mat-option
              *ngFor="let fieldDef of fieldDefs | filterBy: ['related_to_type']:automation.target_model"
              [value]="fieldDef"
              >{{ fieldDef.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <div *ngIf="form.get('objectFieldDef').value as objectFieldDef" formArrayName="objectValueFilters">
          <ng-container *ngIf="objectValueFilters.controls?.length">
            <div
              class="flex flex-col items-center animate__animated animate__fadeInDown animate__faster"
              *ngFor="let objectValueFilter of objectValueFilters.controls; let i = index; let isLast = last"
              [formGroupName]="i"
            >
              <div class="flex items-center w-full">
                <div class="w-full">
                  <app-form-field
                    [fieldDef]="objectFieldDef"
                    [model]="model"
                    [data]="formData"
                    [readonly]="false"
                    [alwaysHideHistory]="true"
                    (onUpdate)="onFieldUpdate($event, objectValueFilter)"
                  ></app-form-field>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container bottom>
    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">Ok</button>
    <button mat-flat-button (click)="cancel.emit()">Cancel</button>
  </ng-container>
</app-automation-builder-form-setup>
